module.exports = __webpack_public_path__ + "assets/img/0ca4357fa7cb0bbdfae6194aa2a3177b.svg";